// Upload de fichier générique (CSV, etc.) pour un client
export async function postClientUpload(clientID, token, uploadType, fileContent) {
    if (!clientID || !token || !uploadType) {
        return { status: 400, message: "Missing parameters" };
    }
    let headers = {
        'Content-Type': 'text/csv',
        'x-mobiuspack-jwt': token,
    };
    let url = getBaseUrl('v1', 'core');
    try {
        const response = await fetch(
            url + `/upload/${clientID}?uploadType=${uploadType}`,
            {
                method: 'POST',
                headers,
                body: fileContent,
            }
        );
        return await response.json();
    } catch (error) {
        return { status: 500, message: error.message || "Error uploading file" };
    }
}
export function getBaseUrl(version = 'v1', domain = 'analytic', privilege = '') {

    let baseUrl = "";
    const subDomain = privilege === '' ? '' : `/${privilege}`

    if (process.env.REACT_APP_ENV === "DEV") {
        baseUrl = `https://api-dev.mobiuspack.io/${version}/api${subDomain}/${domain}`;
    } else if (process.env.REACT_APP_ENV === "PRD") {
        baseUrl = `https://api.mobiuspack.io/${version}/api${subDomain}/${domain}`;
    } else {
        baseUrl = `http://localhost:5000/${version}/api${subDomain}/${domain}`;
    }
    return baseUrl;
}

export function getBaseUrlV1() {
    let baseUrl = "";
    if (process.env.REACT_APP_ENV === "DEV") {
        baseUrl = "https://v1-dev.mobiusback.io";
    } else if (process.env.REACT_APP_ENV === "PRD") {
        baseUrl = "https://v1.mobiusback.io";
    } else {
        baseUrl = "https://v1-dev.mobiusback.io";
    }
    return baseUrl;
}

export function getBaseDocUrl() {
    let baseUrl = "";
    if (process.env.REACT_APP_ENV === "DEV") {
        baseUrl = "https://doc-dev.mobiuspack.io/";
    } else if (process.env.REACT_APP_ENV === "PRD") {
        baseUrl = "https://doc.mobiuspack.io";
    } else {
        baseUrl = "https://doc-dev.mobiuspack.io";
    }
    return baseUrl;
}

export async function getClientInfo(clientID, code) {
    if (!clientID || !code) {
        return { status: 400, message: "clientID or code is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
    }

    let url = getBaseUrl('v1', 'public/client/auth')

    try {
        const response = await fetch(url + `/${clientID}?code=${code}&strategy=v2`, { mode: "cors", cache: "default", headers: headers });
        return await response.json();

    } catch (err) {
        console.error(err);
        return { status: 500, message: err.message || "Unexpected error while fetching client info" };
    }
}

export async function getClient(clientID, token, strategy) {
    if (!clientID || !token) {
        return { status: 400, message: "clientID or token is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v1', 'client')
    let queryStrategy = strategy || 'v2';
    try {
        const response = await fetch(url + `/${clientID}?strategy=${queryStrategy}`, { mode: "cors", cache: "no-cache", headers: headers });
        return await response.json();

    } catch (err) {
        console.error(err);
        return { status: 500, message: err.message || "Unexpected error while fetching client" };
    }
}

export async function updateClient(clientID, token, data) {
    if (!clientID || !token || !data) {
        return { status: 400, message: "clientID token or data is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token,
    }

    let url = getBaseUrl('v3', 'client')
    try {
        const response = await fetch(url + `/${clientID}`, { 
            body: JSON.stringify(data), 
            method: "POST",
            mode: "cors", 
            cache: "default", 
            headers: headers 
        });
        return await response.json();

    } catch (err) {
        console.error(err);
        return { status: 500, message: err.message || "Unexpected error while fetching client" };
    }
}

export async function postNewClientV3(clientID, token, newClient) {

    if (!clientID || !token || !newClient) {
        return { status: 400, message: 'Missing clientID, token or client object' };
    }

    let getURL = getBaseUrl('v3', 'client', 'organization')

    const url = `${getURL}/?expiration=1y`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-mobiuspack-jwt': token
            },
            body: newClient
        });
        return await response.json();
    } catch (error) {
        console.error('Erreur postNewClientV3:', error);
        return { status: 500, message: error.message || 'Error while creating a new client' };
    }
}

export async function deleteClient(clientID, token) {

    if (!clientID || !token) {
        return { status: 400, message: 'Missing clientID or token' };
    }

    let getURL = getBaseUrl('v1', 'client', 'organization')

    const url = `${getURL}/${clientID}/delete`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-mobiuspack-jwt': token
            },
        });
        return await response.json();
    } catch (error) {
        console.error('Erreur deleteClient:', error);
        return { status: 500, message: error.message || 'Error while deleting client' };
    }
}

//onlyReporting=1
export async function getClientList(token) {
    if (!token) {
        return { status: 400, error: "token is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }
    let url = getBaseUrl('v1', 'client', 'admin')
    try {

        const response = await fetch(url + '/list?onlyReporting=1', { mode: "cors", cache: "default", headers: headers });
        return await response.json();
    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error getting client list" };
    }
}

export async function getCarriers(token) {
    if (!token) {
        return { status: 400, error: "token is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }
    let url = getBaseUrl('v1', 'client', 'admin')
    try {

        const response = await fetch(url + '/carriers', { mode: "cors", cache: "default", headers: headers });
        return await response.json();
    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error getting carriers" };
    }
}

export async function getFullClientList(token) {
    if (!token) {
        return { status: 400, error: "token is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }
    let url = getBaseUrl('v1', 'client', 'admin')
    try {

        const response = await fetch(url + '/list', { mode: "cors", cache: "default", headers: headers });
        return await response.json();
    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error getting full client list" };
    }
}


export async function getClientCode(clientID, token) {

    if (!clientID) {
        return { status: 400, message: "clientID is missing" }
    }
    let headers = {
        'method': 'GET',
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v1', 'client')

    try {
        const response = await fetch(url + `/${clientID}/codes`, { mode: "cors", cache: "default", headers: headers });
        return await response.json();

    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error getting client codes" };
    }
}

export async function generateClientCode(clientID, clientToken) {
    if (!clientID) {
        return { status: 400, message: "client is missing" }
    }
    if (!clientToken) {
        return { status: 400, message: "clientToken is missing" }
    }
    let headers = {
        'x-Mobiuspack-jwt': clientToken,
        'Content-Type': 'application/json',
    }

    let url = getBaseUrl('v1', 'client')
    try {
        const response = await fetch(url + `/${clientID}/codes`, { method: 'POST', mode: "cors", cache: "no-cache", headers: headers });
        return await response.json();

    } catch (error) {

        console.error(error);
        return { status: 500, message: error.message || "Error while generating client code" };
    }
}

// ##Client code v2 

export async function getClientCodev2(clientID, token) {

    if (!clientID) {
        return { status: 400, message: "clientID is missing" }
    }
    if (!token) {
        return { status: 400, message: "token is missing" }
    }
    let headers = {
        'method': 'GET',
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v2', 'client')

    try {
        const response = await fetch(url + `/${clientID}/codes`, { mode: "cors", cache: "default", headers: headers });
        return await response.json();

    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error getting client codes (v2)" };
    }
}

export async function deleteClientCodev2(clientID, codeID, token) {

    if (!clientID || !codeID) {
        return { status: 400, message: "clientID or codeDI is missing" }
    }
    if (!token) {
        return { status: 400, message: "token is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v2', 'client', 'organization')

    try {
        const response = await fetch(url + `/${clientID}/code/${codeID}/delete`, { method: 'POST', mode: "cors", cache: "no-cache", headers: headers });
        return await response.json();

    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error deleting client code (v2)" };
    }
}

export async function sendMailClientCodev2(clientID, codeID, token) {

    if (!clientID || !codeID) {
        return { status: 400, message: "clientID or codeDI is missing" }
    }
    if (!token) {
        return { status: 400, message: "token is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v2', 'client')

    try {
        const response = await fetch(url + `/${clientID}/codes/${codeID}/mail`, { method: 'POST', mode: "cors", cache: "no-cache", headers: headers });
        return await response.json();

    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error while sending client code email (v2)" };
    }
}

export async function sendMailClientCodev3(clientID, codeID, mails = [], token) {

    if (!clientID || !codeID) {
        return { status: 400, message: "clientID or codeDI is missing" }
    }
    if (!token) {
        return { status: 400, message: "token is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v3', 'client')

    try {
        const response = await fetch(
            url + `/${clientID}/codes/${codeID}/mail`,
            { 
                method: 'POST',
                mode: "cors",
                cache: "no-cache",
                headers: headers,
                body: JSON.stringify({ mails: mails.map(email => ({ email })) }) // Ajout du body avec les mails
            }

        );
        return await response.json();

    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error while sending client code email (v3)" };
    }
}

export async function generateClientCodev2(clientID, token, codeName, userName, userEmail, mails, permissionList = []) {

    if (!clientID) {
        return { status: 400, message: "client is missing" }
    }
    if (!token) {
        return { status: 400, message: "clientToken is missing" }
    }

    let headers = {
        'x-Mobiuspack-jwt': token,
        'Content-Type': 'application/json',
    }

    let bodyData = {
        "name": codeName,
        "owner": {
            "email": userEmail,
            "name": userName,
        },
        "mails": mails.map((email) => ({
            email: email,
            name: email,
        })),
        "permissions": permissionList
    }
    let url = getBaseUrl('v2', 'client')
    try {
        const response = await fetch(url + `/${clientID}/codes`, {
            method: 'POST',
            mode: "cors",
            cache: "no-cache",
            headers: headers,
            body: JSON.stringify(bodyData), // Ajout du body
        });
        return await response.json();

    } catch (error) {

        console.error(error);
        return { status: 500, message: "Error while generating client code (v2)" };
    }

}

export async function getClientLogo(clientID) {
    if (!clientID) {
        return { status: 400, message: "clientID is missing" }
    }
    let headers = {
        'method': 'GET',
        'Content-type': 'application/json; charset=UTF-8',
    }

    let url = getBaseUrl('v1', 'client', 'public')

    try {
        const response = await fetch(url + `/${clientID}/logo.svg`, { mode: "cors", cache: "default", headers: headers });
        return await response.json();

    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error getting client logo" };
    }
}

export async function getClientLogoV2(clientID, app = false, noCache = false) {
    if (!clientID) {
        return { status: 400, message: "clientID is missing" }
    }
    let headers = {
        'method': 'GET',
        'Content-type': 'application/json; charset=UTF-8',
    }

    let baseUrl = getBaseUrl('v2', 'client', 'public')
    let url = baseUrl + `/${clientID}/logo` + (app ? '?app=true' : '');

    try {
        const response = await fetch(url, { mode: "cors", cache: noCache ? "no-cache" : "default", headers: headers });
        return await response.json();

    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error getting client logo" };
    }
}

export async function postClientLogo(clientID, token, data, app = false) {
    if (!clientID || !token || !data) {
        return { status: 400, message: "clientID, token or data is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let baseUrl = getBaseUrl('v1', 'client', 'organization')
    let url = baseUrl + `/${clientID}/logo` + (app ? '?app=true' : '');

    try {
        const response = await fetch(url, {
            method: 'POST',
            mode: "cors",
            cache: "no-cache",
            headers: headers,
            body: JSON.stringify(data)
        });
        return await response.json();

    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error posting client logo" };
    }
}

export async function getClientLocations(clientID, token) {
    if (!clientID) {
        return { status: 400, message: "clientID is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v1', 'analytic')

    try {
        const response = await fetch(url + `/${clientID}/locations`, { mode: "cors", cache: "default", headers: headers });
        return await response.json();


    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error fetching client locations" };
    }

}

export async function getClientFirebaseLocations(clientID, token) {
    if (!clientID) {
        return { status: 400, message: "clientID is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v1', 'client')

    try {
        const response = await fetch(url + `/${clientID}/locations`, { mode: "cors", cache: "default", headers: headers });
        return await response.json();


    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error fetching client firebase locations" };
    }

}

export async function getAllOrganizations(clientID, token, roles = [], localOrganizations = [], noCache = false) {
    if (!clientID) {
        return { status: 400, message: "clientID is missing", data: [] };
    }

    if (!roles.includes('mobiuspack-admin')) {
        return { status: 200, message: "Access denied as admin returning local orga", data: localOrganizations };
    }

    const normalizeName = (name) =>
        (name || '')
            .toString()
            .normalize('NFD') // décompose accents
            .replace(/[\u0300-\u036f]/g, '') // supprime accents
            .replace(/\s+/g, '') // supprime tous les espaces (intérieurs + bords)
            .toLowerCase();

    const headers = {
        'Content-Type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    };

    const url = getBaseUrl('v1', 'client', 'admin');

    try {
        const response = await fetch(`${url}/list`, {
            method: 'GET',
            mode: 'cors',
            cache: noCache ? 'no-cache' : 'default',
            headers
        });

        const remoteData = await response.json();
        const remoteOrganizations = Array.isArray(remoteData.results) ? remoteData.results : [];

        const localMap = localOrganizations.reduce((acc, localOrg) => {
            const key = normalizeName(localOrg.displayName);
            if (key) acc[key] = localOrg;
            return acc;
        }, {});

        const usedKeys = new Set();

        const merged = remoteOrganizations.map(remoteOrg => {
            const rawName = remoteOrg.clientName || remoteOrg.name || '';
            const matchKey = normalizeName(rawName);
            const local = localMap[matchKey];

            if (local) usedKeys.add(matchKey);

            const clientName = rawName.trim();
            const displayName = (local?.displayName || clientName).trim();
            const clientID = (remoteOrg.id || "").trim()

            return {
                clientName,
                displayName,
                clientID: clientID,
                emails: Array.isArray(local?.emails) ? local.emails : [],
                id: local?.id || '',
                active: Boolean(local)
            };
        });

        // Ajout des organisations locales non présentes dans le fetch
        const localOnly = localOrganizations
            .filter(localOrg => !usedKeys.has(normalizeName(localOrg.displayName)))
            .map(localOrg => ({
                clientName: localOrg.clientName,
                displayName: localOrg.displayName,
                clientID: "",
                emails: Array.isArray(localOrg.emails) ? localOrg.emails : [],
                id: localOrg.id || '',
                active: true
            }));


        const finalList = [...localOnly, ...merged];

        const sorted = finalList.sort((a, b) =>
            a.displayName.localeCompare(b.displayName, 'fr', { sensitivity: 'base' })
        );

        return {
            status: 200,
            message: 'success',
            data: sorted
        };

    } catch (error) {
        console.error("Error fetching admin organizations:", error);
        return {
            status: 500,
            message: error.message || "Error fetching organizations",
            data: []
        };
    }
}

export async function getClientFlows(clientID, token, locationFilter) {
    if (!clientID) {
        return { status: 400, message: "clientID is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v1', 'analytic')
    let query = Array.isArray(locationFilter) && locationFilter.length > 0
        ? `?locationFilter=${encodeURIComponent(locationFilter.join(','))}`
        : '';

    try {
        const response = await fetch(url + `/${clientID}/flows${query}`, { mode: "cors", cache: "default", headers: headers });
        return await response.json();


    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error fetching client flows" };
    }
}

export async function getClientFirebaseFlows(clientID, token) {
    if (!clientID) {
        return { status: 400, message: "clientID is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v1', 'client')

    try {
        const response = await fetch(url + `/${clientID}/flows`, { mode: "cors", cache: "default", headers: headers });
        return await response.json();


    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error fetching client firebase flows" };
    }
}

export async function getClientFirebaseContexts(clientID, token) {
    if (!clientID) {
        return { status: 400, message: "clientID is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v1', 'client')

    try {
        const response = await fetch(url + `/${clientID}/contexts`, { mode: "cors", cache: "default", headers: headers });
        return await response.json();

    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error fetching client contexts" };
    }
}


export async function getClientFirebaseContextsV2(clientID, token) {
    if (!clientID) {
        return { status: 400, message: "clientID is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v2', 'client')

    try {
        const response = await fetch(url + `/${clientID}/contexts`, { mode: "cors", cache: "default", headers: headers });
        return await response.json();

    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error fetching client contexts" };
    }
}

export async function getClientFirebaseMaintenances(clientID, token) {
    if (!clientID) {
        return { status: 400, message: "clientID is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v1', 'client')

    try {
        const response = await fetch(url + `/${clientID}/maintenances`, { mode: "cors", cache: "default", headers: headers });
        return await response.json();

    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error fetching client maintenances" };
    }
}

export async function postNewFirebaseContextV2(clientID, token, clientData) {
    if (!clientID || !token || !clientData) {
        return { status: 400, message: "clientID, token or clientData is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v2', 'client', 'organization')

    try {
        const response = await fetch(url + `/${clientID}/contexts`, {
            method: 'POST',
            mode: "cors",
            cache: "default",
            headers: headers,
            body: JSON.stringify(clientData)
        });
        return await response.json();

    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error posting contexts" };
    }
}

export async function updateFirebaseContextV2(clientID, token, contextData, contextId) {
    if (!clientID || !token || !contextData || !contextId) {
        return { status: 400, message: "clientID, token, contextData or contextId is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v2', 'client', 'organization')

    try {
        const response = await fetch(url + `/${clientID}/context/${contextId}`, {
            method: 'POST',
            mode: "cors",
            cache: "default",
            headers: headers,
            body: JSON.stringify(contextData)
        });
        return await response.json();

    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error updating contexts" };
    }
}

export async function postNewFirebaseContextV3(clientID, token, contextData) {
    if (!clientID || !token || !contextData) {
        return { status: 400, message: "clientID, token or contextData is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v3', 'client', 'organization')

    try {
        const response = await fetch(url + `/${clientID}/contexts`, {
            method: 'POST',
            mode: "cors",
            cache: "no-cache",
            headers: headers,
            body: JSON.stringify(contextData)
        });
        return await response.json();

    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error posting contexts" };
    }
}

export async function updateFirebaseContextV3(clientID, token, contextData, contextId) {
    if (!clientID || !token || !contextData || !contextId) {
        return { status: 400, message: "clientID, token, contextData or contextId is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v3', 'client', 'organization')

    try {
        const response = await fetch(url + `/${clientID}/context/${contextId}`, {
            method: 'POST',
            mode: "cors",
            cache: "no-cache",
            headers: headers,
            body: JSON.stringify(contextData)
        });
        return await response.json();

    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error updating contexts" };
    }
}

export async function deleteFirebaseContext(clientID, token, contextId) {
    if (!clientID || !token || !contextId) {
        return { status: 400, message: "clientID, token, contextData or contextId is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }
    let url = getBaseUrl('v1', 'client', 'organization')
    try {
        const response = await fetch(url + `/${clientID}/context/${contextId}/delete`, {
            method: 'POST',
            mode: "cors",
            cache: "no-cache",
            headers: headers,
        });
        return await response.json();
    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error deleting a context" };
    }
}
// Enable/Disable a context
export async function updateStatusFirebaseContext(clientID, token, contextId, newStatus) {
    if (!clientID || !token || !contextId) {
        return { status: 400, message: "clientID, token, contextData or contextId is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }
    let url = getBaseUrl('v3', 'client', 'organization')
    try {
        const response = await fetch(url + `/${clientID}/context/${contextId}/status?status=${newStatus}`, {
            method: 'POST',
            mode: "cors",
            cache: "no-cache",
            headers: headers,
        });
        return await response.json();
    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error updating context status" };
    }
}

export async function getClientReference(clientID, token) {
    if (!clientID) {
        return { status: 400, message: "clientID is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v1', 'analytic')

    try {
        const response = await fetch(url + `/${clientID}/parcelRef`, { mode: "cors", cache: "default", headers: headers });
        return await response.json();


    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error fetching client parcel references" };
    }

}

export async function getClientConfig(clientID, token, configName) {
    if (!clientID) {
        return { status: 400, message: "clientID is missing" };
    }
    if (!token) {
        return { status: 400, message: "token is missing" };
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        "x-mobiuspack-jwt": token,
    }
    let baseUrl = getBaseUrl('v1', 'client')
    try {
        const response = await fetch(baseUrl + `/${clientID}/config?type=` + configName, { mode: "cors", cache: "no-store", headers: headers });
        return await response.json();
    }
    catch (error) {
        console.error(error)
        return { status: 500, message: error.message || "Error getting client config" };
    }
}

export async function sendVerificationMail(clientID, userId, organizationId, token) {
    const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

    if (!token) {
        return { status: 400, message: "token is missing" };
    }
    if (!userId) {
        return { status: 400, message: "userId is missing" };
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        "x-mobiuspack-jwt": token,
    }

    let sendEmailBody = {
        client_id: auth0ClientId,
        user_id: userId,
    };
    if (organizationId) {
        sendEmailBody.organization_id = organizationId;
    }
    let baseUrl = getBaseUrl('v2', 'client')
    try {
        const res = await fetch(baseUrl + `/${clientID}/mail`, { mode: "cors", cache: "no-cache", headers: headers, body: JSON.stringify(sendEmailBody) });
        if (res.status === 200) {
            return res
        } else {
            throw new Error("Error while sending verification email, status: " + res.status)
        }
    }
    catch (err) {
        console.error(err.message)
        return { status: 500, message: err.message || 'Error while sending verification email' }
    }
}

export async function postClientApiKey(clientID, clientName, isAdmin, token, expireValue, profileValue, refreshStatus) {
    if (!clientID) {
        return { status: 400, message: "clientID is missing" };
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token,
    };

    const domain = isAdmin ? 'admin' : '';
    const version = isAdmin ? 'v1' : 'v2';
    let url = getBaseUrl(version, 'client', domain);

    try {
        const response = await fetch(url + `/${clientID}/generateApiKey`, {
            method: 'POST',
            mode: "cors",
            cache: "no-cache",
            headers: headers,
            body: JSON.stringify({
                "clientName": clientName || "",
                "expire": expireValue || "1d", // Added body with expire property
                "profile": profileValue || "user-poc",
                "refresh": refreshStatus || "false"
            }),
        });
        return response.json();
    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error generating API key" };
    }
}

export async function postClientWebhook(clientID, token, webhook, userName, userEmail) {
    if (!clientID) {
        return { status: 400, message: "clientID is missing" };
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token,
    };

    let url = getBaseUrl('v2', 'client');

    let bodyData = {
        ...webhook,
        "owner": {
            "email": userEmail,
            "name": userName,
        }
    }

    try {
        const response = await fetch(url + `/${clientID}/webhook`, {
            method: 'POST',
            mode: "cors",
            cache: "no-cache",
            headers: headers,
            body: JSON.stringify(bodyData),
        });
        return response.json();
    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error generating API key" };
    }
}

export async function getClientWebhooks(clientID, token) {
    if (!clientID) {
        return { status: 400, message: "clientID is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v2', 'client')

    try {
        const response = await fetch(url + `/${clientID}/webhooks`, { mode: "cors", cache: "default", headers: headers });
        return response.json();

    } catch (error) {
        console.error(error);
        return { status: 500, message: error.message || "Error while getting client webhooks" }
    }
}

export async function deleteClientWebhook(clientID, webhookID, token) {

    if (!clientID || !webhookID) {
        return { status: 400, message: "clientID or webhookID is missing" }
    }
    if (!token) {
        return { status: 400, message: "token is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v2', 'client', 'organization')

    try {
        const response = await fetch(url + `/${clientID}/webhook/${webhookID}/delete`, { method: 'POST', mode: "cors", cache: "no-cache", headers: headers });
        return await response.json();

    } catch (error) {
        console.error('Error while deleting webhook:', error);
        return { status: 500, message: 'Error while deleting webhook' };
    }
}

export async function postClientConfig(clientID, token, configName, configData) {

    if (!clientID || !configName) {
        return { status: 400, message: "clientID or configName is missing" }
    }
    if (!token) {
        return { status: 400, message: "token is missing" }
    }
    let headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'x-mobiuspack-jwt': token
    }

    let url = getBaseUrl('v1', 'client')

    try {
        const response = await fetch(url + `/${clientID}/config?type=` + configName, {
            method: 'POST',
            mode: "cors",
            cache: "no-cache",
            headers: headers,
            body: JSON.stringify(configData),
        });
        return await response.json();

    } catch (error) {
        console.error('Error while posting a new client config:', error);
        return { status: 500, message: error.message || 'Error while posting a new client config' };
    }
}

export async function sendLocations(clientID, token, file) {

    if (!clientID || !token || !file) {
        return { status: 400, message: 'Missing clientID, token or file' };
    }

    let getURL = getBaseUrl('v1', 'client')

    const formData = new FormData();
    formData.append('file', file);

    const url = `${getURL}/${clientID}/locations/bulk`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'x-mobiuspack-jwt': token
            },
            body: formData
        });
        return await response.json();
    } catch (error) {
        console.error('Error sendLocations:', error);
        return { status: 500, message: error.message || 'Error while posting locations' };
    }
}

export async function postNewLocation(clientID, token, newLocation) {

    if (!clientID || !token || !newLocation) {
        return { status: 400, message: 'Missing clientID, token or the location object' };
    }

    let getURL = getBaseUrl('v1', 'client')

    const url = `${getURL}/${clientID}/locations`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-mobiuspack-jwt': token
            },
            body: newLocation
        });
        return await response.json();
    } catch (error) {
        console.error('Erreur postNewLocation:', error);
        return { status: 500, message: error.message || 'Error while posting a new location' };
    }
}

export async function updateLocationById(clientID, token, newLocation, locationId) {

    if (!clientID || !token || !newLocation || !locationId) {
        return { status: 400, message: 'Missing clientID, token, the location object or the location ID' };
    }

    let getURL = getBaseUrl('v1', 'client', 'organization')

    const url = `${getURL}/${clientID}/location/${locationId}`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-mobiuspack-jwt': token
            },
            body: newLocation
        });
        return await response.json();
    } catch (error) {
        console.error('Erreur updateLocationById:', error);
        return { status: 500, message: error.message || 'Erreur during update location' };
    }
}

export async function deleteLocationById(clientID, token, locationId) {

    if (!clientID || !token || !locationId) {
        return { status: 400, message: 'Missing clientID, token or the location id' };
    }

    let getURL = getBaseUrl('v1', 'client', 'organization')

    const url = `${getURL}/${clientID}/location/${locationId}/delete`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'x-mobiuspack-jwt': token
            },
        });
        return await response.json();
    } catch (error) {
        console.error('Error deleteLocation:', error);
        return { status: 500, message: error.message || 'Error while deleting location' };
    }
}

/* MANAGE FLOWS */

export async function postNewFlow(clientID, token, newFlow) {

    if (!clientID || !token || !newFlow) {
        return { status: 400, message: 'Missing clientID, token or the flow object' };
    }

    let getURL = getBaseUrl('v1', 'client')

    const url = `${getURL}/${clientID}/flows`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-mobiuspack-jwt': token
            },
            body: newFlow
        });
        return await response.json();
    } catch (error) {
        console.error('Erreur postNewFlow:', error);
        return { status: 500, message: error.message || 'Error while posting a new flow' };
    }
}


export async function updateFlowById(clientID, token, newFLow, flowId) {

    if (!clientID || !token || !newFLow || !flowId) {
        return { status: 400, message: 'Missing clientID, token, the flow object or the flow ID' };
    }

    let getURL = getBaseUrl('v1', 'client', 'organization')

    const url = `${getURL}/${clientID}/flow/${flowId}`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-mobiuspack-jwt': token
            },
            body: newFLow
        });
        return await response.json();
    } catch (error) {
        console.error('Error updateFlowById:', error);
        return { status: 500, message: error.message || 'Error while updating flow' };
    }
}

export async function deleteFlowById(clientID, token, flowId) {

    if (!clientID || !token || !flowId) {
        return { status: 400, message: 'Missing clientID, token or the flow id' };
    }

    let getURL = getBaseUrl('v1', 'client', 'organization')

    const url = `${getURL}/${clientID}/flow/${flowId}/delete`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'x-mobiuspack-jwt': token
            },
        });
        return await response.json();
    } catch (error) {
        console.error('Error deleteFlow:', error);
        return { status: 500, message: error.message || 'Error while deleting flow' };
    }
}

export async function forceAppReload(clientID, token, type) {

    if (!clientID || !token) {
        return { status: 400, message: 'Missing clientID or token' };
    }
    if (!type || !['publish', 'update'].includes(type)) {
        return { status: 400, message: 'Missing publish or update query data' };
    }

    let getURL = getBaseUrl('v1', 'client', 'organization')

    const url = `${getURL}/${clientID}/appReload?${type}=true`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'x-mobiuspack-jwt': token
            },
        });
        return await response.json();
    } catch (error) {
        console.error('Error while forcing the app reload:', error);
        return { status: 500, message: error.message || 'Error while forcing the app reload' };
    }
}

/* MANAGE MAINTENANCES */

export async function postNewMaintenance(clientID, token, newMaintenance) {

    if (!clientID || !token || !newMaintenance) {
        return { status: 400, message: 'Missing clientID, token or the maintenance object' };
    }

    let getURL = getBaseUrl('v1', 'client')

    const url = `${getURL}/${clientID}/maintenance`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-mobiuspack-jwt': token
            },
            body: newMaintenance
        });
        return await response.json();
    } catch (error) {
        console.error('Error postNewMaintenance:', error);
        return { status: 500, message: error.message || 'Error while posting a new maintenance' };
    }
}

export async function updateMaintenanceById(clientID, token, newMaintenance, maintenanceId) {

    if (!clientID || !token || !newMaintenance || !maintenanceId) {
        return { status: 400, message: 'Missing clientID, token, the maintenance object or the maintenance ID' };
    }

    let getURL = getBaseUrl('v1', 'client', 'organization')

    const url = `${getURL}/${clientID}/maintenance/${maintenanceId}`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-mobiuspack-jwt': token
            },
            body: newMaintenance
        });
        return await response.json();
    } catch (error) {
        console.error('Error updateMaintenanceById:', error);
        return { status: 500, message: error.message || 'Error while updating maintenance' };
    }
}

export async function deleteMaintenanceById(clientID, token, maintenanceId) {

    if (!clientID || !token || !maintenanceId) {
        return { status: 400, message: 'Missing clientID, token or the maintenance id' };
    }

    let getURL = getBaseUrl('v1', 'client', 'organization')

    const url = `${getURL}/${clientID}/maintenance/${maintenanceId}/delete`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'x-mobiuspack-jwt': token
            },
        });
        return await response.json();
    } catch (error) {
        console.error('Error deleteMaintenance:', error);
        return { status: 500, message: error.message || 'Error while deleting maintenance' };
    }
}

export const submitLabelBatch = async ({ env, clientID, flowID, parcels, token }) => {
    const ENV_URLS = {
        lcl: 'http://127.0.0.1:5000/v1/api/admin/core/parcels',
        dev: 'https://api-dev.mobiuspack.io/v1/api/admin/core/parcels',
        prd: 'https://api.mobiuspack.io/v1/api/admin/core/parcels'
    };
    const getCode = (val, arr, start = '') => {
        const index = arr.indexOf(val);
        return index >= 0 ? `${index + 1}`.padStart(2, start) : '00';
    };

    const EANtoGTIN = (ean) => '0000000000';
    const VALIDE_TYPES = ['LIGHT-X', 'LIGHT-G', 'SOFT', 'BIGBAG', 'MASTER', 'BOX', 'SLEEVE', 'CAISSE', 'PALETTE', 'BAC'];
    const VALIDE_SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXS', 'XXL'];
    const VALIDE_VERSIONS = ['01', '02', '03', '04', '05'];
    const VALIDE_SERIES = ['NA', 'PF', 'PS', 'MB']

    if (!token) throw new Error('Token utilisateur introuvable');

    const payload = {
        batch: { clientID, flowID },
        data: parcels.map(({ quantity, type, size, version, series }) => {
            const typeCode = getCode(type, VALIDE_TYPES, '0');
            const sizeCode = getCode(size, VALIDE_SIZES, '');
            const versionCode = getCode(version, VALIDE_VERSIONS);
            const seriesCode = VALIDE_SERIES.includes(series) ? series : 'NA';
            const ean = `${seriesCode}${typeCode}${sizeCode}-${versionCode}`;
            return {
                quantity,
                parcel: {
                    EAN: ean,
                    GTIN: EANtoGTIN(ean),
                    version,
                    size,
                    type,
                    tripCount: '0'
                }
            };
        })
    };

    const apiUrl = ENV_URLS[env];

    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-mobiuspack-jwt': token
        },
        body: JSON.stringify(payload)
    });

    const result = await response.json();

    return result.parcels?.flatMap(p =>
        p.parcel?.file?.map(file => ({
            name: file.name + file.extension,
            url: file.access.url,
            extension: file.extension,
            expirationDate: file.access.expirationDate
        }))
    ) || [];
};

export const postCollaboratorInvitations = async (clientID = "", token = {}, emails = []) => {

    let getURL = getBaseUrl('v1', 'client', 'organization');

    return fetch(`${getURL}/${clientID}/collaborators/invite`, {
        method: 'POST',
        headers: {
            'x-mobiuspack-jwt': token,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ emails }),
    }).then(res => res.json());

};
 
export const getClientExceptionTracking = async (clientId, token = '', filters = {}) => {
    const baseUrl = getBaseUrl('v1', 'client', 'admin');
    const params = new URLSearchParams(filters).toString();
    const url = `${baseUrl}/exception/${clientId}/tracking?${params}`;

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'x-mobiuspack-jwt': token,
        },
    });

    if (!response.ok) throw new Error('Failed to fetch exception tracking');
    return response.json();
};

export const getClientExceptionRetry = async (clientId, token = '', filters = {}) => {
    const baseUrl = getBaseUrl('v1', 'client', 'admin');
    const params = new URLSearchParams(filters).toString();
    const url = `${baseUrl}/exception/${clientId}/tracking?${params}`;

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-mobiuspack-jwt': token,
        },
    });

    if (!response.ok) throw new Error('Failed to post tracking exception retry');

    // Gérer les réponses vides ou non-JSON
    const text = await response.text();
    if (!text) return {}; // Retourner un objet vide si pas de contenu

    try {
        return JSON.parse(text);
    } catch (error) {
        console.warn('Response is not valid JSON:', text);
        return {}; // Retourner un objet vide si JSON invalide
    }
};


export const handleReplayException = async (clientId, token = '', exceptionId) => {
    if (!clientId || !token || !exceptionId) {
        throw new Error('clientId, token and exceptionId are required');
    }

    const baseUrl = getBaseUrl('v1', 'client', 'admin');
    const url = `${baseUrl}/exception/${clientId}/tracking/${exceptionId}`;

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-mobiuspack-jwt': token,
        },
    });

    if (!response.ok) throw new Error('Failed to replay exception');

    // Gérer les réponses vides ou non-JSON
    const text = await response.text();
    if (!text) return {}; // Retourner un objet vide si pas de contenu

    try {
        return JSON.parse(text);
    } catch (error) {
        console.warn('Response is not valid JSON:', text);
        return {}; // Retourner un objet vide si JSON invalide
    }
};

export const updateExceptionTracking = async (clientId, exceptionId, updateData, token = '') => {
    if (!clientId || !exceptionId || !token || !updateData) {
        throw new Error('clientId, exceptionId, updateData and token are required');
    }

    const baseUrl = getBaseUrl('v1', 'client', 'admin');
    const url = `${baseUrl}/exception/${clientId}/tracking/${exceptionId}`;

    const response = await fetch(url, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'x-mobiuspack-jwt': token,
        },
        body: JSON.stringify(updateData),
    });

    if (!response.ok) throw new Error('Failed to update exception');

    // Gérer les réponses vides ou non-JSON
    const text = await response.text();
    if (!text) return {}; // Retourner un objet vide si pas de contenu

    try {
        return JSON.parse(text);
    } catch (error) {
        console.warn('Response is not valid JSON:', text);
        return {}; // Retourner un objet vide si JSON invalide
    }
};

export const deleteExceptionTracking = async (clientId, exceptionId, token = '') => {
    if (!clientId || !exceptionId || !token) {
        throw new Error('clientId, exceptionId and token are required');
    }

    const baseUrl = getBaseUrl('v1', 'client', 'admin');
    const url = `${baseUrl}/exception/${clientId}/tracking/${exceptionId}`;

    const response = await fetch(url, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'x-mobiuspack-jwt': token,
        },
    });

    if (!response.ok) throw new Error('Failed to delete exception');

    // Gérer les réponses vides ou non-JSON
    const text = await response.text();
    if (!text) return {}; // Retourner un objet vide si pas de contenu

    try {
        return JSON.parse(text);
    } catch (error) {
        console.warn('Response is not valid JSON:', text);
        return {}; // Retourner un objet vide si JSON invalide
    }
};

export const postNewOrganization = async (newOrgClientId, name, displayName, metadata, token = '') => {
    if (!newOrgClientId || !name || !displayName || !token) {
        return { status: 400, message: 'clientId, name, displayName, and token are required' };
    }

    const baseUrl = getBaseUrl('v2', 'client', 'organization');
    const url = `${baseUrl}/${newOrgClientId}/organizations`;
    const queryBody = { name, displayName, metadata };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-mobiuspack-jwt': token,
            },
            body: JSON.stringify(queryBody),
        });

        return await response.json();
        
    } catch (error) {
        console.error('Error creating organization:', error);
        return { status: 500, message: error.message || 'Error while creating organization' };
    }
};

export const addUserInOrganizationWithRole = async (newOrgClientId, orgId, userAuth0Id, rolesId, token = '') => {
    if (!newOrgClientId || !orgId || !userAuth0Id || !rolesId || !token) {
        return { status: 400, message: 'newOrgClientId, orgId, userAuth0Id, rolesId, and token are required' };
    }

    const baseUrl = getBaseUrl('v2', 'client', 'organization');
    const url = `${baseUrl}/${newOrgClientId}/organizations/${orgId}/users/${userAuth0Id}`;
    const queryBody = { rolesId };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-mobiuspack-jwt': token,
            },
            body: JSON.stringify(queryBody),
        });

        return await response.json();
        
    } catch (error) {
        console.error(`Error adding user to organization with role ${rolesId.join(', ')}:`, error);
        return { status: 500, message: error.message || `Error while adding user to organization with role ${rolesId.join(', ')}` };
    }
};

export const removeUserRoleFromOrganization = async (clientId, orgId, userAuth0Id, roleId, token = '') => {
    if (!clientId || !orgId || !userAuth0Id || !roleId || !token) {
        return { status: 400, message: 'clientId, orgId, userAuth0Id, roleId, and token are required' };
    }

    const baseUrl = getBaseUrl('v2', 'client', 'organization');
    const url = `${baseUrl}/${clientId}/organizations/${orgId}/users/${userAuth0Id}/roles/${roleId}`;

    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'x-mobiuspack-jwt': token,
            },
        });

        return await response.json();
        
    } catch (error) {
        console.error(`Error removing role ${roleId} from user in organization:`, error);
        return { status: 500, message: error.message || `Error while removing role ${roleId} from user in organization` };
    }
};

export const getAuth0Roles = async (clientID, token = '') => {
    if (!clientID || !token) {
        return { status: 400, message: 'clientID and token are required' };
    }

    const baseUrl = getBaseUrl('v2', 'client');
    const url = `${baseUrl}/${clientID}/organizations/roles`;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-mobiuspack-jwt': token,
            },
        });

        return await response.json();
        
    } catch (error) {
        console.error(`Error fetching Auth0 roles:`, error);
        return { status: 500, message: error.message || `Error while fetching Auth0 roles` };
    }
};

//create user in organization with role and send invitation email
export const createUserInOrganizationWithInvitation = async (clientID, orgId, email, roleId, token = '') => {
    if (!clientID || !orgId || !email || !roleId || !token) {
        return { status: 400, message: 'clientID, orgId, email, roleId, and token are required' };
    }

    const baseUrl = getBaseUrl('v2', 'client', 'organization');
    const url = `${baseUrl}/${clientID}/organizations/${orgId}/users`;
    const queryBody = { email, roleId };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-mobiuspack-jwt': token,
            },
            body: JSON.stringify(queryBody),
        });

        return await response.json();
        
    } catch (error) {
        console.error(`Error creating user in organization with role ${roleId}:`, error);
        return { status: 500, message: error.message || `Error while creating user in organization with role ${roleId}` };
    }
};

//add user to org and send an invitation by email
export const sendEmailInvitation = async (clientID, inviterName = '', orgId, emails, rolesId = [], token = '', scopes = []) => {
    if (!clientID || !inviterName || !orgId || !emails || !rolesId || !token) {
        return { status: 400, message: 'clientID, inviterName, orgId, emails, rolesId, and token are required' };
    }

    const baseUrl = getBaseUrl('v2', 'client');
    const url = `${baseUrl}/${clientID}/collaborators/invite`;
    const body = { inviterName, emails, organizationId: orgId, rolesId, ...(scopes.length > 0 && { scopes }) };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-mobiuspack-jwt': token,
            },
            body: JSON.stringify(body),
        });

        return await response.json();
        
    } catch (error) {
        console.error(`Error creating user in organization with roles ${rolesId}:`, error);
        return { status: 500, message: error.message || `Error while creating user in organization with roles ${rolesId}` };
    }
};

// Get all users with their roles in a specific organization - read-only
export const getUserForAnOrganizationWithRoles = async (clientID, orgId, token = '', page = 1, limit = 10) => {
    if (!clientID || !orgId || !token) {
        return { status: 400, message: 'clientID, orgId, and token are required' };
    }

    const baseUrl = getBaseUrl('v3', 'client');
    const url = `${baseUrl}/${clientID}/organizations/${orgId}/users?page=${page}&limit=${limit}`;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-mobiuspack-jwt': token,
            },
        });

        return await response.json();
        
    } catch (error) {
        console.error(`Error fetching users in organization ${orgId}:`, error);
        return { status: 500, message: error.message || `Error while fetching users in organization ${orgId}` };
    }
};


// Add a role to a user in a specific organization
export const addOranizationUserRole = async (clientID, orgId, userId, rolesId = [], token = '') => {
    if (!clientID || !orgId || !userId || !rolesId || !token) {
        return { status: 400, message: 'clientID, orgId, userId, rolesId, and token are required' };
    }

    const baseUrl = getBaseUrl('v2', 'client', 'organization');
    const url = `${baseUrl}/${clientID}/organizations/${orgId}/users/${userId}`;
    const queryBody = { rolesId };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-mobiuspack-jwt': token,
            },
            body: JSON.stringify(queryBody),
        });

        return await response.json();
        
    } catch (error) {
        console.error(`Error adding roles ${rolesId.join(', ')} to user in organization ${orgId}:`, error);
        return { status: 500, message: error.message || `Error while adding roles ${rolesId.join(', ')} to user in organization ${orgId}` };
    }
};

// Delete a role from a user in a specific organization
export const deleteOrganizationUserRole = async (clientID, orgId, userId, rolesId = [], token = '') => {
    if (!clientID || !orgId || !userId || !rolesId || !token) {
        return { status: 400, message: 'clientID, orgId, userId, rolesId, and token are required' };
    }

    const baseUrl = getBaseUrl('v2', 'client', 'organization');
    const url = `${baseUrl}/${clientID}/organizations/${orgId}/roles/${userId}/delete`;
    const queryBody = { rolesId };

    try {
        const response = await fetch(url, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
                'x-mobiuspack-jwt': token,
            },
            body: JSON.stringify(queryBody),
        });

        return await response.json();
        
    } catch (error) {
        console.error(`Error deleting roles ${rolesId.join(', ')} from user in organization ${orgId}:`, error);
        return { status: 500, message: error.message || `Error while deleting roles ${rolesId.join(', ')} from user in organization ${orgId}` };
    }
};

export const updateOrganizationUserRole = async (clientID, organizationId, userId, newRoleId, scopes = [], token = '') => {
    if (!clientID || !organizationId || !userId || !newRoleId || !token) {
        return { status: 400, message: 'clientID, organizationId, userId, newRoleId, and token are required' };
    }

    const baseUrl = getBaseUrl('v3', 'client', 'organization');
    const url = `${baseUrl}/${clientID}/organizations/${organizationId}/roles/${userId}/update`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-mobiuspack-jwt': token,
            },
            body: JSON.stringify({ newRoleId, ...(scopes.length > 0 ? { scopes } : {scopes : null}) }),
        });

        return await response.json();

    } catch (error) {
        console.error(`Error updating role for user ${userId} in organization ${organizationId}:`, error);
        return { status: 500, message: error.message || `Error while updating role for user ${userId}` };
    }
};

export async function getReversePoints(clientID, token) {
    if (!clientID || !token) {
        return { status: 400, message: 'Missing clientID or token' };
    }

    const url = getBaseUrl('v2', 'client');

    try {
        const response = await fetch(
            `${url}/${clientID}/reverse?transporteur=mondialrelay`,
            {
                mode: 'cors',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                    'x-mobiuspack-jwt': token,
                },
            }
        );
        return response.json();
    } catch (error) {
        console.error('Error fetching reverse points:', error);
        return { status: 500, message: error.message || 'Error fetching reverse points' };
    }
}

/**
 * Get carrier performance state from client's config/options
 * Returns the carrierPerfContacts map with structure:
 * {
 *   [deliveryContext]: {
 *     contactedAt: ISO_DATE,
 *     contactedBy: userEmail,
 *     contactedByName: userName,
 *     affectedClientIDs: [clientID1, clientID2],
 *     lastEmailSentAt: ISO_DATE,
 *     emailSentCount: number
 *   }
 * }
 */
export async function getCarrierPerfState(clientID, token) {
    try {
        const response = await getClientConfig(clientID, token, 'options');
        
        if (response.status === 200 && response.results?.backInterface?.state?.carrierPerfContacts) {
            return {
                status: 200,
                results: response.results.backInterface.state.carrierPerfContacts
            };
        }
        return { status: 200, results: {} };
    } catch (error) {
        console.error('Error loading carrier perf state:', error);
        return { status: 500, error: error.message };
    }
}

/**
 * Save carrier performance state to client's config/options
 * Uses merge logic - will not overwrite other config options
 */
export async function saveCarrierPerfState(clientID, token, contactedMap) {
    try {
        const configData = {
            backInterface: {
                state: {
                    carrierPerfContacts: contactedMap
                }
            }
        };
        
        return await postClientConfig(clientID, token, 'options', configData);
    } catch (error) {
        console.error('Error saving carrier perf state:', error);
        return { status: 500, error: error.message };
    }
}

/**
 * Get master container capacity from client's config/options
 * (backInterface.dashboardData.masterContainerCapacity). Returns null when unset —
 * callers apply their own default (40).
 */
export async function getMasterContainerCapacity(clientID, token) {
    try {
        const response = await getClientConfig(clientID, token, 'options');
        const value = response?.results?.backInterface?.dashboardData?.masterContainerCapacity;
        return {
            status: response?.status ?? 500,
            results: (typeof value === 'number' && value > 0) ? value : null,
        };
    } catch (error) {
        console.error('Error loading master container capacity:', error);
        return { status: 500, error: error.message };
    }
}

/**
 * Save master container capacity to client's config/options
 * Uses merge logic - will not overwrite other config options
 */
export async function saveMasterContainerCapacity(clientID, token, capacity) {
    try {
        const configData = {
            backInterface: {
                dashboardData: {
                    masterContainerCapacity: capacity
                }
            }
        };

        return await postClientConfig(clientID, token, 'options', configData);
    } catch (error) {
        console.error('Error saving master container capacity:', error);
        return { status: 500, error: error.message };
    }
}

/**
 * Save a single dashboard option (backInterface.dashboardData.<key>) to client's config/options
 * Uses merge logic - will not overwrite other config options
 * NB: le back met cette config en cache 5 min (getClientDashboardConfig) — les métriques
 * qui en dépendent (ex. dormantStock/deadStockDays) peuvent refléter l'ancienne valeur
 * pendant ce délai.
 */
export async function saveDashboardDataOption(clientID, token, key, value) {
    try {
        const configData = {
            backInterface: {
                dashboardData: {
                    [key]: value
                }
            }
        };

        return await postClientConfig(clientID, token, 'options', configData);
    } catch (error) {
        console.error(`Error saving dashboard option ${key}:`, error);
        return { status: 500, error: error.message };
    }
}

/**
 * Get shared views state from client's config/options
 * Returns array of shared views for the organization
 * 
 * Structure:
 * {
 *   path: string (URL with potential dynamic tokens like @today, -Xd),
 *   label: string,
 *   isDynamic: boolean,
 *   createdAt: ISO_DATE,
 *   createdBy: string (email),
 *   createdByName: string
 * }
 */
export async function getSharedViewsState(clientID, token) {
    try {
        const response = await getClientConfig(clientID, token, 'options');
        
        if (response.status === 200 && response.results?.backInterface?.state?.sharedViews) {
            return {
                status: 200,
                results: response.results.backInterface.state.sharedViews
            };
        }
        return { status: 200, results: [] };
    } catch (error) {
        console.error('Error loading shared views state:', error);
        return { status: 500, error: error.message };
    }
}

/**
 * Save shared views state to client's config/options
 * Uses merge logic - will not overwrite other config options
 */
export async function saveSharedViewsState(clientID, token, viewsArray) {
    try {
        const configData = {
            backInterface: {
                state: {
                    sharedViews: viewsArray
                }
            }
        };
        
        return await postClientConfig(clientID, token, 'options', configData);
    } catch (error) {
        console.error('Error saving shared views state:', error);
        return { status: 500, error: error.message };
    }
}

/**
 * Get onboarding state from client's config/options
 * @param {string} clientID - The client ID
 * @param {string} token - JWT token
 * @returns {Promise<{status: number, results: object}>}
 * Structure: {
 *   users: {
 *     "userId": {
 *       hasCompleted: boolean,
 *       lastViewedAt: ISO_DATE,
 *       totalViews: number,
 *       slidesViewed: array,
 *       timeSpent: number,
 *       version: string
 *     }
 *   }
 * }
 */
export async function getOnboardingState(clientID, token) {
    try {
        const response = await getClientConfig(clientID, token, 'options');
        
        if (response.status === 200 && response.results?.backInterface?.state?.onboarding) {
            return {
                status: 200,
                results: response.results.backInterface.state.onboarding
            };
        }
        return { status: 200, results: { users: {} } };
    } catch (error) {
        console.error('Error loading onboarding state:', error);
        return { status: 500, error: error.message };
    }
}

/**
 * Save onboarding state to client's config/options
 * Uses merge logic - will not overwrite other config options
 * @param {string} clientID - The client ID
 * @param {string} token - JWT token
 * @param {object} onboardingData - Onboarding state data
 */
export async function saveOnboardingState(clientID, token, onboardingData) {
    try {
        const configData = {
            backInterface: {
                state: {
                    onboarding: onboardingData
                }
            }
        };
        
        return await postClientConfig(clientID, token, 'options', configData);
    } catch (error) {
        console.error('Error saving onboarding state:', error);
        return { status: 500, error: error.message };
    }
}